// @flow

export const titleColumnId: 'column_title' = 'column_title';
export const getColumnId = (index: number) => (`row_${index}`);
export const totalColumnId: 'column_total' = 'column_total';

export const getRowId = (index: number) => (`row_${index}`);
export const totalRowId: 'row_total' = 'row_total';
